<p-toast position="top-right"></p-toast>
<div class="pay-Salary-responsive p-g">
    <div class="p-g-12">
        <div class="card card-w-title p-table-tecfolk-fix">
            <div class="p-g">
                <div class="p-g-12 p-md-6">
                    <h1 style="margin-top: 0px;">{{setLabel("employeeSalaryManagementLabel")}}</h1>
                </div>
                <div class="p-g-6">
                </div>
            </div>
            <div>
                <p-table [value]="users" [paginator]="true" [rows]="25" [responsive]="true" [loading]="loading"
                    [first]="first" (onPage)="onPageChange($event)">

                    <ng-template pTemplate="caption"
                        style="text-align: left; display: flex; flex-direction: column; gap: 10px;">

                        <div class="reportMainFilter">
                            <div class="reportMainFields">
                                <div class="filterFields">
                                    <span class="fieldTitle">{{setLabel("searchByEmployeeNameLabel")}}</span>
                                    <input id="searchEmployee" #searchEmployee
                                        (keyup)="searchLocal(employee.name, 'name')" [(ngModel)]="employee.name"
                                        autocomplete="off" pinputtext="" [placeholder]='setLabel("searchHerePlaceholderLabel")' type="text"
                                        name="name" class="p-inputtext p-corner-all p-state-default p-widget">
                                </div>
                                <div class="filterFields">
                                    <span class="fieldTitle">{{setLabel("monthLabel")}}</span>
                                    <p-dropdown [options]="months" name="month" [(ngModel)]="currentMonth"
                                        (onChange)="onChangeMonthDropDown()" class="feeDropdown">
                                    </p-dropdown>


                                </div>
                                <div class="filterFields">
                                    <span class="fieldTitle">{{setLabel("yearLabel")}}</span>
                                    <p-dropdown [options]="years" name="year" [(ngModel)]="currentYear"
                                        (onChange)="onChangeYearDropDown()" class="feeDropdown">
                                    </p-dropdown>
                                </div>
                                <div class="reportMainBtn">

                                    <span [pTooltip]='setLabel("clearSearchTooltip")' [disabled]="loading" (click)="clear()"> <i
                                            class="pi pi-times"></i></span>
                                </div>
                            </div>

                            <div class="reportMainBtn">
                                <span [pTooltip]='setLabel("clearSearchTooltip")' class="hideOnLaptop" [disabled]="loading"
                                    (click)="clear()"> <i class="pi pi-times"></i></span>

                                <!-- <button style="background: #ffffff; color: #0e2031; margin-right: 8px; height: 25px;"
                                    (click)="clear()"
                                    class="p-button p-widget p-state-default p-corner-all p-button-text-only"><i
                                        class="clear-Search fa fa-eraser"></i>&nbsp;Clear
                                    Search
                                </button> -->

                                <span [pTooltip]='setLabel("issuesEmployeeSalaryTooltip")' [disabled]="loading"
                                    (click)="issuesEmployeeSalary()"> <i class="fa fa-money money"></i></span>
                                <!-- <button
                                    style="background: #5da30c; color: white; margin-right: 8px; height: 25px; width: 100%; "
                                    (click)="issuesEmployeeSalary()" [disabled]="!isIssueEmployeeSalaryButton"
                                    class=" issue-Button p-button p-widget p-state-default p-corner-all p-button-text-only"><i
                                        class="fa fa-save"></i>&nbsp;&nbsp;Issues Employee Salary
                                </button> -->
                                <!-- <i class="fa-solid fa-money-bill-transfer"></i> -->
                            </div>

                        </div>

                    </ng-template>

                    <ng-template pTemplate="header">
                        <tr>
                            <th>
                                <p-checkbox binary="true" [(ngModel)]="isHeaderCheckBox" (onChange)="setAllCheckBoxes()"
                                    [disabled]="!(users.length > 0)">
                                </p-checkbox>&nbsp;
                                {{setLabel("selectAllLabel")}}
                            </th>
                            <th>{{setLabel("photoLabel")}}</th>
                            <th>{{setLabel("employeeNoLabel")}}</th>
                            <th>{{setLabel("nameLabel")}}</th>
                            <th>{{setLabel("designationLabel")}}</th>
                            <th>{{setLabel("salaryLabel")}}</th>
                            <th>{{setLabel("trainerShareLabel")}}</th>
                            <th>{{setLabel("totalSalaryLabel")}}</th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-users>
                        <tr class="tr">
                            <td>
                                <div class="mobile-Lable">{{setLabel("selectAllLabel")}}</div>
                                <p-checkbox value="users" [(ngModel)]="users.isSelectedForPay" [binary]="true"
                                    (onChange)="setIssueSalaryButtonVisibility()">
                                </p-checkbox>
                            </td>
                            <td>
                                <div class="mobile-Lable" style="display: flex; align-items: center;">{{setLabel("imageLabel")}}</div>

                                <a (click)="openPhoto(users.profile)">
                                    <img [alt]="" src="{{config.Server + config.employeeImagePath + users.profile}}"
                                        onerror="this.onerror=null;this.src=`assets/layout/images/avatarBoyImage.png`;"
                                        width="60" style="vertical-align: middle" />
                                </a>
                            </td>
                            <td>
                                <div class="mobile-Lable">{{setLabel("employeeCodeLabel")}}</div>

                                {{users.employeeCode}}
                            </td>
                            <td>
                                <div class="mobile-Lable">{{setLabel("nameLabel")}}</div>
                                {{users.name}}
                            </td>
                            <td>
                                <div class="mobile-Lable">{{setLabel("designationLabel")}}</div>
                                {{getDesignationTitle(users.designation)}}
                            </td>
                            <td>
                                <div class="mobile-Lable">{{setLabel("salaryLabel")}}</div>

                                <input type="number" style="width: 80%;" [placeholder]='setLabel("salaryPlaceholderLabel")' name="salary"
                                    [(ngModel)]="users.salary" />
                            </td>
                            <td>

                                <div class="mobile-Lable">{{setLabel("trainerIdLabel")}}</div>

                                <div *ngIf="!users.trainerId">
                                    {{setLabel("notTrainerLabel")}}
                                </div>
                                <div *ngIf="users.trainerId">
                                    <div class="mobile-Lable">{{setLabel("trainerShareLabel")}}</div>

                                    <input type="number" style="width: 80%;" [placeholder]='setLabel("trainerSharePlaceholderLabel")'
                                        name="trainerShare" [(ngModel)]="users.trainerShare" />
                                </div>
                            </td>
                            <td>

                                <div class="mobile-Lable">{{setLabel("totalSalaryLabel")}}</div>

                                <input type="number" style="width: 80%;" [placeholder]='setLabel("totalSalaryPlaceholderLabel")' name="totalSalary"
                                    [(ngModel)]="users.totalSalary" />
                            </td>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="emptymessage" let-columns>
                        <tr style="color: black;">
                            <td colspan="3" style="padding: 24px; font-family: monospace;font-size: large;">
                                {{setLabel("allSalariesIssuedLabel")}}
                            </td>
                        </tr>
                    </ng-template>

                </p-table>
            </div>

            <div *ngIf="imgPreview" (click)="closePhotoPreview()"
                style="position: fixed; top: 0; left: 0; height: 100vh; width: 100vw; z-index: 999999; display: flex; align-items: center; justify-content: center; background: #000000cf;">
                <svg (click)="closePhotoPreview()"
                    style="width: 20px; position: absolute; top: 30px; right: 40px; color: #fff; cursor: pointer;"
                    aria-hidden="true" focusable="false" data-prefix="fas" data-icon="times"
                    class="svg-inline--fa fa-times fa-w-11" role="img" xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 352 512">
                    <path fill="currentColor"
                        d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z">
                    </path>
                </svg>
                <img src="{{imgPreviewImg}}"
                    onerror="this.onerror=null;this.src=`assets/layout/images/avatarBoyImage.png`;"
                    style="width: 25vw; height: auto;background: #fff;" />
            </div>
        </div>
    </div>
</div>

<div id="salariesInvoice" style="display: none;">
    <div class="invoice-box invoiceBreakPage" *ngFor="let employee of allEmployeeArray"
        style="padding: 0px !important;  width: 57mm; max-width: 57mm; margin: 0 !important;">
        <div style="width: 57mm;max-width: 57mm;">

            <img [src]=" (company.bannerImage ? config.Server + 'assets/layout/images/companies/' + company.bannerImage : 'assets/layout/images/logoCompany.png')"
                alt="Company Logo" style="
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 58%;
    margin-top: 3px;
    margin-bottom: 2px;
" />
            <div style="
    text-align: center;
    font-size: 11px;
    line-height: 14px;
    color: black;
">
                {{ branch.name }}
            </div>
            <div style="
    text-align: center;
    font-size: 11px;
    line-height: 14px;
    color: black;
">
                {{ branch.address }}
            </div>
            <div style="
    text-align: center;
    font-size: 11px;
    line-height: 15px;
    color: black;
">
                {{ branch.phone }}
            </div>
            <table
                style="border-collapse: collapse; font-size: 12px; font-size: 9px;border: 1px solid black;line-height: 12px; margin-top: 8px;">

                <tbody>
                    <tr>
                        <td style="font-size: 10px;text-align: center;padding: 0px; font-weight: bold;">{{setLabel("salaryInvoice#Label")}}
                        </td>
                        <td style="font-size: 10px;text-align: center; padding: 0px; font-weight: bold;"></td>
                        <td style="font-size: 10px;text-align: center; padding: 0px;font-weight: bold;">{{setLabel("createdLabel")}}</td>
                    </tr>
                    <tr>
                        <td style="font-size: 10px;text-align: center; padding: 0px;">{{employee.salary.invoice}}
                        </td>
                        <td style="font-size: 10px;text-align: center; padding: 0px;"></td>
                        <td style="font-size: 10px;text-align: center; padding: 0px;">{{payInvoiceCurrentTime |
                            date:
                            'd/M/yy, h:mm a'}}</td>
                    </tr>

                </tbody>
            </table>

            <table
                style="border-collapse: collapse; font-size: 12px; font-size: 9px;margin-top: 3px; line-height: normal;">

                <thead
                    style=" text-align: center;font-weight: bold; font-size: 12px; font-size: 9px; background-color: black;color: white;">
                    <tr style="background-color: black;color: white; border: 1px solid black;">
                        <th style="width: 40px;  word-break: break-word; font-size: 10px;">{{setLabel("employeeNameLabel")}}</th>
                        <th style="width: 40px;  word-break: break-word; font-size: 10px; ">{{setLabel("salaryMonthLabel")}}</th>
                        <th style="width: 40px;  word-break: break-word; font-size: 10px; ">{{setLabel("issuedSalaryLabel")}}</th>
                    </tr>
                </thead>

                <tbody>
                    <span>
                        <tr>
                            <td style="font-size: 9px;border:1px solid black;text-align: center;">
                                {{employee.name}}</td>
                            <td style="font-size: 9px;border:1px solid black;text-align: center;">
                                {{getMonthName(currentMonth)}}
                                -
                                {{currentYear}}</td>
                            <td style="font-size: 9px;border:1px solid black;text-align: center;">
                                {{employee.salary.totalPaid}}</td>
                        </tr>
                    </span>
                </tbody>

            </table>

            <div
                style=" text-align: center;padding-top: 6px; font-size: 10px; font-weight: bold;color: black;white-space: nowrap;">
                {{setLabel("softwareByTecfolkLabel")}}
            </div>

        </div>
    </div>
</div>